import Vue from 'vue';
import VueSanitizeHtml from 'vue-sanitize-html-plugin';

Vue.use(VueSanitizeHtml, {
  allowedTags: [ 'a', 'br', 'p', 'b' ],
  allowedAttributes: {
    'a': [ 'href' ],
  }
});
